import {
    RECEIVE_SERP_URL_DOMAIN,
    RECEIVE_REFINEMENTS,
    RECEIVE_KEYWORDS,
    RECEIVE_ARRIVAL_DATE,
    RECEIVE_DEPARTURE_DATE,
    REDIRECT,
    SHOW_DATES_POPUP,
    HIDE_DATES_POPUP,
    UPDATE_SEARCH
} from '../actions/action-types';
import {encodeSerpUrl} from '../utils/serp';
import {refinementsToQuery} from '../utils/refinements';

export function _updateSerpUrl(state) {
    const {
        arrivalDate,
        departureDate,
        refinements,
        keywords,
        _serpUrlDomain
    } = state;

    let query = refinementsToQuery(refinements);
    query.keywords = keywords;

    const datedQuery = {...query};
    if (arrivalDate) {
        datedQuery.arrival = arrivalDate;
    }
    if (departureDate) {
        datedQuery.departure = departureDate;
    }

    state.serpUrl = encodeSerpUrl(_serpUrlDomain, query);
    state.datedSerpUrl = encodeSerpUrl(_serpUrlDomain, datedQuery);

    return state;
}

export default function search(state = {}, action) {
    switch (action.type) {
        case UPDATE_SEARCH:
            return {
                ...state,
                ...action.payload
            };
        case RECEIVE_SERP_URL_DOMAIN:
            return {
                ...state,
                _serpUrlDomain: action.domain
            };

        case RECEIVE_REFINEMENTS:
            return _updateSerpUrl({
                ...state,
                refinements: {
                    ...state.refinements,
                    ...action.refinements
                }
            });

        case RECEIVE_KEYWORDS:
            return _updateSerpUrl({
                ...state,
                keywords: action.keywords
            });

        case RECEIVE_ARRIVAL_DATE:
            return _updateSerpUrl({
                ...state,
                arrivalDate: action.date
            });

        case RECEIVE_DEPARTURE_DATE:
            return _updateSerpUrl({
                ...state,
                departureDate: action.date
            });

        case REDIRECT:
            setTimeout(() => {
                window.location = action.url;
            }, 0);
            return state;

        case HIDE_DATES_POPUP:
            return {
                ...state,
                showDatesPopup: false
            };

        case SHOW_DATES_POPUP:
            return {
                ...state,
                showDatesPopup: true,
                propertyName: action.propertyName,
                tripleId: action.tripleId,
                listingUri: action.listingUri,
                location: action.location
            };

        default:
            return state;
    }
}
